<script lang="ts" setup>
import { computed } from "vue";

import { formatRouteAddress } from "@/utils/routes";

const props = defineProps<{
  firstPickup: string | null;
  lastDelivery: string | null;
}>();

const address = computed<string | null>(() => formatRouteAddress(props.firstPickup, props.lastDelivery));
</script>

<template>
  <span class="font-weight-500 text-grey-darken-3" data-qa="invoice-route">{{ address ?? "—" }}</span>
</template>
